<template lang="pug">
  include ./../../mixins
  +b.modal.--decorate
    +b.close(
      slot="top-right"
      @click="$emit('close')"
    )
      +b.I.icon.--type_close
    +e.content
      +e.info-title
        +b.P.caption.--size_2.--color_black.--fw_bold {{ title }}
      +b.P.text.--fs_xl.--lh_xl.--color_black(v-if="subtitle") {{ subtitle }}
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
  data() {
    return {
      
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/InfoModal.vue